<template>
  <div class="user-detail container-fluid">

<!-- LOADING -->
<div v-if="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Caricamento...</span>
  </div>
  <div class="loading-text">Caricamento in corso...</div>
</div>

<!-- CARD TITOLO (come la vuoi tu) -->
<div class="card mb-2 shadow-sm">
  <div class="card-body d-flex align-items-center justify-content-between">
    <h5 class="mb-1">I miei dati</h5>
  </div>
</div>

<!-- CARD DATI -->
<div class="card shadow-sm">

  <div class="card-body">

    <div v-if="user" class="row">

      <!-- ETICHETTE -->
      <div class="col-12 col-md-6 labels">
        <ul class="list-unstyled">
          <li>Nome</li>
          <li>Cognome</li>
          <li>Codice fiscale</li>
          <li>Nome dell'Ente</li>
          <li>Codice fiscale dell'Ente</li>
          <li>Regione/Provincia autonoma di riferimento</li>
          <li>Email istituzionale (NO Pec)</li>
          <li>Recapito telefonico dell'ufficio</li>
          <li v-if="user.privileges?.length">Permessi</li>
        </ul>
      </div>

      <!-- VALORI -->
      <div class="col-12 col-md-6 values">
        <ul class="list-unstyled">
          <li>{{ user.name || '—' }}</li>
          <li>{{ user.surname || '—' }}</li>
          <li>{{ user.fiscalcode || '—' }}</li>
          <li>{{ user.organization || '—' }}</li>
          <li>{{ user.organization_fiscal_code || '—' }}</li>
          <li>{{ user.region_name || '—' }}</li>
          <li>{{ user.email || '—' }}</li>
          <li>{{ user.phone || '—' }}</li>

          <!-- PERMESSI -->
          <li v-if="user.privileges?.length">
            <div class="d-flex flex-wrap gap-2">
              <span 
                v-for="p in user.privileges" 
                :key="p.id" 
                class="custom-badge"
              >
                {{ p.description }}
              </span>
            </div>
          </li>

        </ul>
      </div>

    </div>

    <div v-else>
      Caricamento...
    </div>

  </div>
</div>
```

  </div>
</template>

<script>
import ToastDialog from '../../../components/common/ToastDialog.vue'
import BreadcrumbElement from '../../../components/common/BreadcrumbElement.vue'
import toastable from '../../../mixins/toastable'

export default {
  name: 'UserDetailView',
  mixins: [toastable],
  components: {
    ToastDialog,
    BreadcrumbElement
  },
  data() {
    return {
      user: null,
      currentUser: this.$root.user,
      errors: null,
      isLoading: true
    }
  },
  async mounted() {
    try {
      this.isLoading = true
      const response = await this.$root.$api.get(`/user-detail/${this.currentUser.id}`)
      this.user = response.data
    } catch (error) {
      this.showErrorToast('Errore', 'Impossibile caricare i dati utente')
      console.error(error)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    showErrorToast(title, message) {
      this.toastError = true
      this.toastTitle = title
      this.toastMessage = message
    }
  }
}
</script>

<style scoped>
.user-detail {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.labels li,
.values li {
  padding: 0.6rem 0;
  border-bottom: 1px solid #eee;
}

.labels li:last-child,
.values li:last-child {
  border-bottom: none;
}

.labels li {
  font-weight: 600;
  color: #444;
}

.values li {
  color: #222;
  word-break: break-word;
}

.custom-badge {
  display: inline-block;
  padding: 0.4rem 0.7rem;
  border: 1px solid #0b3d91;
  color: #0b3d91;
  background-color: #ffffff;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

/* LOADING */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: #0d6efd;
}
</style>
